// Import dependencies
import axios from "axios";
import wrapper from "axios-cache-plugin";

const logging = false;
axios.interceptors.request.use((request) => {
  if (logging) console.log("Starting Request", request);
  return request;
});

axios.interceptors.response.use((response) => {
  if (logging) console.log("Response:", response);
  return response;
});

let Api = wrapper(axios, {
  maxCacheSize: 20,
  ttl: 24 * 60000
});
Api.__addFilter(/products/);

export default Api;
